import { Pipe, PipeTransform } from '@angular/core';

import { RdsChip } from '../chips/index';
import { RdsTextFilter } from './text-filter.model';

/**
 * Turn `RdsTextFilter` into RdsChips
 * @author Zach Edwards <zach.edwards@mtna.us>
 */
@Pipe({
  name: 'rdsTextFiltersToChips',
})
export class RdsTextFiltersToChipsPipe implements PipeTransform {
  transform(value: Array<RdsTextFilter> | null | undefined): Array<RdsChip> {
    if (!value || !value.length) {
      return [];
    }
    return value
      .filter((f) => !!f.parameter)
      .map(
        (f) =>
          // We can safely do a null assertion because of the filter
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          new RdsChip(`${f.parameter!.label}${f.text ? ` "${f.text}"` : ''}`, f.parameter!.type + f.text)
      );
  }
}
